<script>
import { mapGetters } from 'vuex';
import DyteAPI from 'dashboard/api/integrations/dyte';
import LiveKitAPI from 'dashboard/api/integrations/livekit';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    conversationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapGetters({ appIntegrations: 'integrations/getAppIntegrations' }),
    videoIntegration() {
      // Check for LiveKit first, then Dyte
      const livekit = this.appIntegrations.find(
        integration =>
          integration.id === 'livekit' && !!integration.hooks.length
      );
      if (livekit) return { type: 'livekit', integration: livekit };

      const dyte = this.appIntegrations.find(
        integration => integration.id === 'dyte' && !!integration.hooks.length
      );
      if (dyte) return { type: 'dyte', integration: dyte };

      return null;
    },
    isVideoIntegrationEnabled() {
      return !!this.videoIntegration;
    },
    helpText() {
      if (!this.videoIntegration) return '';
      const key = this.videoIntegration.type === 'livekit' ? 'LIVEKIT' : 'DYTE';
      return this.$t(`INTEGRATION_SETTINGS.${key}.START_VIDEO_CALL_HELP_TEXT`);
    },
  },
  mounted() {
    if (!this.appIntegrations.length) {
      this.$store.dispatch('integrations/get');
    }
  },
  methods: {
    async onClick() {
      this.isLoading = true;
      try {
        if (this.videoIntegration.type === 'livekit') {
          await LiveKitAPI.createAMeeting(this.conversationId);
        } else {
          await DyteAPI.createAMeeting(this.conversationId);
        }
      } catch (error) {
        const key =
          this.videoIntegration.type === 'livekit' ? 'LIVEKIT' : 'DYTE';
        useAlert(this.$t(`INTEGRATION_SETTINGS.${key}.CREATE_ERROR`));
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <NextButton
    v-if="isVideoIntegrationEnabled"
    v-tooltip.top-end="helpText"
    icon="i-ph-video-camera"
    slate
    faded
    sm
    @click="onClick"
  />
</template>
